const object = [{ "customerName": null, "customerNumber": null, "invoiceNumber": null, "invoiceAmount": null, "dueDate": null, "notes": null }];


const tableDataReducer = (state = object, action) => {
    switch (action.type) {
        case 'TABLE_DATA':
            return action.payload;

        default:
            return state
    }
}
export default tableDataReducer;